import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { toast } from "react-toastify";
import App from "./App";
import store,{ persistor } from "./store/store";

import "admin-lte/dist/css/adminlte.css";
import "./index.scss";
import "./tailwind.css";
import "./i18n";
import { PersistGate } from "redux-persist/integration/react";

toast.configure({
  autoClose: 3000,
  draggable: false,
  position: "top-right",
  hideProgressBar: false,
  newestOnTop: true,
  closeOnClick: true,
  rtl: false,
  pauseOnVisibilityChange: true,
  pauseOnHover: true,
});

let hasShown401Toast = false;

const originalFetch = window.fetch;

window.fetch = async (...args) => {
  try {
    const response = await originalFetch(...args);

    if (response.status === 401 && !hasShown401Toast) {
      hasShown401Toast = true;

      toast.error("Session expired. Please login again.");
      sessionStorage.clear();
      localStorage.clear();
      window.location.href = "/login";
    }

    return response;
  } catch (error) {
    // Network or fetch error (not an HTTP error)
    toast.error("Network error. Please try again.");
    console.error("Global fetch error:", error);
    throw error; // rethrow so existing .catch() chains work
  }
};

ReactDOM.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
    <App />
    </PersistGate>
  </Provider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();
